import { useRouter } from 'vue-router';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { SendNotificationToken } from '@/actions/send-notification-token';
import StorageService from '@/utils/StorageService';
import { ref } from 'vue';
import { is } from 'date-fns/locale';
import { getPlatforms, isPlatform } from '@ionic/vue';

export const usePushNotification = () => {
  const token = ref('');

  const checkPermissions = async () => {
    const result = await FirebaseMessaging.checkPermissions();
    return result.receive;
  };

  const requestPermissions = async () => {
    const result = await FirebaseMessaging.requestPermissions();
    return result.receive;
  };

  const getToken = async () => {
    if(isPlatform('capacitor') && isPlatform('mobile')){
      const result = await FirebaseMessaging.getToken();
      return result.token;
    }
    return '';
  };

  const deleteToken = async () => {
    await FirebaseMessaging.deleteToken();
  };

  const getDeliveredNotifications = async () => {
    const result = await FirebaseMessaging.getDeliveredNotifications();
    return result.notifications;
  };

  const removeDeliveredNotifications = async () => {
    await FirebaseMessaging.removeDeliveredNotifications({
      notifications: []
    });
  };

  const removeAllDeliveredNotifications = async () => {
    await FirebaseMessaging.removeAllDeliveredNotifications();
  };

  const subscribeToTopic = async () => {
    await FirebaseMessaging.subscribeToTopic({ topic: 'news' });
  };

  const unsubscribeFromTopic = async () => {
    await FirebaseMessaging.unsubscribeFromTopic({ topic: 'news' });
  };

  const removeAllListeners = async () => {
    await FirebaseMessaging.removeAllListeners();
  };

  const registerNotifications = async () => {
    let permStatus = await checkPermissions();
    console.log('permStatus', permStatus);

    if (permStatus === 'prompt') {
      permStatus = await requestPermissions();
    }

    if (permStatus !== 'granted') {
      throw new Error('User denied permissions!');
    }

    // denied になる場合は、アプリの設定から通知を許可する必要がある
    // https://capacitor-firebase.web.app/docs/messaging#permission-status
    // ユーザーに通知を許可するように促すメッセージを表示する必要がある
    //

    // Android
    // https://developer.android.com/training/notify-user/permissions?hl=ja#runtime-approval

    // iOS
    // https://developer.apple.com/documentation/usernotifications/asking_permission_to_use_notifications?language=objc

  }

  const sendNotificationToken = async (fcm_token: string, apns_token?: string) => {
    return false;
  }

  // アプリがフォアグラウンドになった時に、getDeliveredNotifications()で通知を取得する


  return {
    token,
    getToken,
    deleteToken,
    getDeliveredNotifications,
    removeDeliveredNotifications,
    removeAllDeliveredNotifications,
    subscribeToTopic,
    unsubscribeFromTopic,
    removeAllListeners,
    registerNotifications,
    checkPermissions,
    requestPermissions,
    sendNotificationToken,
  }
}
